module.exports = __webpack_public_path__ + "static/media/patient.ae002717.png";